import React from 'react';
import CHILE_OFFER_FLOW_STEP_IDS from '../../../../../constants/factoring/chile-offer-flow-step-ids';
import BulletListWithItems from '../../../../lists/BulletListWithItems';
import CessionTypeSelectorStep from '../../steps/CessionTypeSelectorStep';

export default function buildCessionTypeSelectorConfiguration({
  t,
  selectedCessionType,
  setSelectedCessionType,
  selectedProvider,
  allDocumentsHaveXML,
}) {
  return {
    id: CHILE_OFFER_FLOW_STEP_IDS.CESSION_TYPE_SELECTOR,
    title: '¿Cómo quieres ceder tus facturas?',
    tooltipTitle: (
      <BulletListWithItems
        title={t('internal-cession-recommended-title')}
        titleProps={{ fontSize: 'inherit' }}
        items={[
          {
            id: 1,
            primary: 'Es más rápido, cede con un click',
            color: 'inherit',
          },
          {
            id: 2,
            primary: 'Más fácil, no rellenas formularios',
            color: 'inherit',
          },
          {
            id: 3,
            primary: 'Garantizamos seguridad en todo momento',
            color: 'inherit',
          },
        ]}
        disablePadding
        dense
      />
    ),
    component: CessionTypeSelectorStep,
    props: {
      selectedCessionType,
      setSelectedCessionType,
      selectedProvider,
      allDocumentsHaveXML,
    },
  };
}
